<script setup>
import DataTable from "@/components/global-themed/table/DataTable.vue";
import TableHeaderRow from "@/components/global-themed/table/TableHeaderRow.vue";
import TableHeaderCell from "@/components/global-themed/table/TableHeaderCell.vue";
import TableBody from "@/components/global-themed/table/TableBody.vue";
import TableRow from "@/components/global-themed/table/TableRow.vue";
import TableCell from "@/components/global-themed/table/TableCell.vue";
import ZeroContent from "@/components/global-themed/ZeroContent.vue";
import BaseCard from "@/components/global-themed/BaseCard.vue";
import {usePyCrawlFormatters} from "@/composables/admin/usePyCrawlAnalytics";

defineProps({
    jobs: {type: Array, required: true},
});

const {formatDateTime} = usePyCrawlFormatters();
</script>

<template>
  <BaseCard>
    <h2 class="tw-text-xl tw-font-semibold tw-text-font-primary tw-mb-4">
      Next Queued Jobs
    </h2>
    <DataTable>
      <TableHeaderRow class="!tw-grid-cols-12">
        <TableHeaderCell :col-span="3">
          Domain
        </TableHeaderCell>
        <TableHeaderCell :col-span="5">
          Start URL
        </TableHeaderCell>
        <TableHeaderCell :col-span="2">
          Queued At
        </TableHeaderCell>
        <TableHeaderCell :col-span="2">
          Logs
        </TableHeaderCell>
      </TableHeaderRow>
      <TableBody v-if="jobs.length > 0">
        <TableRow
          v-for="(job, index) in jobs"
          :key="index"
        >
          <TableCell :col-span="3">
            {{ job.domain }}
          </TableCell>
          <TableCell :col-span="5">
            <span class="tw-break-all">{{ job.start_url }}</span>
          </TableCell>
          <TableCell :col-span="2">
            {{ formatDateTime(job.enqueue_time) }}
          </TableCell>
          <TableCell :col-span="2">
            <a
              :href="job.cloudwatch_url"
              target="_blank"
              class="tw-text-blue tw-underline tw-text-sm"
            >CloudWatch</a>
          </TableCell>
        </TableRow>
      </TableBody>
      <ZeroContent v-else>
        No jobs currently queued.
      </ZeroContent>
    </DataTable>
  </BaseCard>
</template>
